<template>
<div>
  <o-main-progress class="elevation-0 background-transparent" v-if="loading"/>
  <div v-else>
    <logo-layout 
    :title="mensajeError"
    :description="siguientePaso"
  />
  <v-layout justify-center>
    <v-btn v-if="tokenConfirmado === 1" color="primary"  @click.stop="enviarMail">
      {{$t('pages.incrustado.reenviarCorreo')}}
    </v-btn>
    <v-btn v-if="rutaPortal != null" target="_top" color="primary" :href="rutaPortal">
      {{$t('incrustado.portalCD')}}
    </v-btn>
  </v-layout>
    <v-layout row justify-right px-2>
    <v-menu
      v-if="idiomas.length > 1"
      transition="scale-transition" origin="top right" 
      offset-y nudge-top="-4" left
      style="margin-left:auto !important;"
      class="my-1"
    >
      <v-btn class="menuBtn ma-0" large flat slot="activator" :disabled="cambiandoIdioma" :loading="cambiandoIdioma">
        <span style="margin-right:8px">
          {{$t('general.idiomas.' + getIdioma)}}
        </span>
        <v-icon style="margin-right: 5px;" large class="custom-icon icon-language" />
      </v-btn>
      <v-list>
        <template v-for="(idioma, index) in idiomas">
          <v-list-tile
            :key="'language-' + idioma.value"
            @click="cambiarIdioma(idioma.value)"
          >
            <v-list-tile-title>{{ idioma.text }}</v-list-tile-title>
          </v-list-tile>
          <v-divider
            v-if="index + 1 < idiomas.length"
            :key="'divider-' + idioma.value"
          />
        </template>
      </v-list>
    </v-menu>
  </v-layout>
  </div>
  
</div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['actorId', 'token'],
  data () {
    return {
      tokenConfirmado: 0,
      loading: true,
      rutaPortal: null,
      cambiandoIdioma: false
    }
  },
  async created () {
    try {
      this.rutaPortal = await this.confirmar({
        actorId: this.actorId,
        token: this.token
      })
      this.tokenConfirmado = 0
      this.loading = false
    } catch (error) {
      this.loading = false
      this.tokenConfirmado = 1
      this.addAlert({texto: error.message, color: 'error'})
    }
  },
  computed: {
    mensajeError () {
      switch (this.tokenConfirmado) {
        case 0:
          return this.$t('pages.incrustado.cuentaActivada')
        case 1:
          return this.$t('pages.incrustado.errorActivacion')
        case 2:
          return this.$t('pages.incrustado.errorReenvio')
        case 3:
          return this.$t('pages.incrustado.correoReenviado')
      }
      return null
    },
    siguientePaso () {
      switch (this.tokenConfirmado) {
        case 0:
          return this.$t('pages.incrustado.continuarProceso')
        case 1:
          return this.$t('pages.incrustado.pulsarBoton')
        case 2:
          return this.$t('pages.incrustado.iniciarProceso')
        case 3:
          return this.$t('pages.incrustado.cerrarVentana')
      }
      return null
    },
    idiomas () {
      return this.getIdiomas.map(x => {
        return {
          value: x,
          text: this.$t('general.idiomas.' + x)
        }
      }).sort((a, b) => a.text.localeCompare(b.text.localeCompare))
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      confirmar: 'login/confirmarCorreo',
      setIdioma: 'login/cambiarIdioma',
      reenviarMail: 'login/reenviarMail'
    }),
    async cambiarIdioma (v) {
      try {
        this.cambiandoIdioma = true
        await this.setIdioma(v)
      } catch (error) {
        console.log(error)
        this.addAlert({texto: error.message, color: 'error'})
      } finally {
        this.cambiandoIdioma = false
      }
    },
    async enviarMail () {
      try {
        this.loading = true
        await this.reenviarMail(this.actorId)
        this.tokenConfirmado = 3
        this.loading = false
      } catch (error) {
        this.loading = false
        this.tokenConfirmado = 2
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/incrustado/mensajeConfirmar.vue